//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as commonModule } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services'
import { SYSTEM_SERVICE_PROVIDER_NAME, $TIMEOUT_SERVICE_NAME, $STATE_SERVICE_NAME, $SCOPE_SERVICE_NAME, $STATE_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_NAME, SystemServiceProvider, SystemService, } from '../../services/system'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, UserSessionService } from '../../services/user-session'
import { ROUTE_SERVICE_NAME, RouteService } from '../../services/route'

import { ScopeBaseGrid } from '../common/common.base.grid.controller'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { COMPONENTS_MODULE_NAME, DETAILS_DIRECTIVE_NAME } from './components'

import { RoutesController } from './routes.controller'

//#region Asset Imports

import * as TEMPLATE from './routes.tpl.html'

//#endregion


//#region Consts

const CONTROLER_NAME: string = 'RoutesController'
const MODULE_NAME: string = 'simax.routes'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Routes'
const MENU_INDEX: number = 9
const STATE_NAME: string = 'routes'
const STATE_URL: string = '/routes'

//#endregion


//#region Setup

const module = angular.module(MODULE_NAME, [
    commonModule,
    apiModule,
    SERVICES_MODULE_NAME,
    COMPONENTS_MODULE_NAME
])

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'localDictionary',
    USER_SESSION_SERVICE_NAME,
    ROUTE_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: ScopeBaseGrid,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        userSessionService: UserSessionService,
        routeService: RouteService,
        systemService: SystemService
    ) => new RoutesController(
        $scope,
        $state,
        $timeout,
        api,
        localDictionary,
        userSessionService,
        routeService,
        systemService,
        RouteService.REFERENCE_TYPE,
        RouteService.SIMAX_MODULE_NAME
    )])

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Route_IdRoute',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.ROUTE_LIST)
                && !loggedOperator.hasPermission(Activity.ROUTE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.RouteModule)) {

                MenuItem.addMenuItem(ConfigHelper.getIconName(ConfigHelper.Icon.ROUTES),
                    'routes',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

//#endregion

export default MODULE_NAME